import { css, keyframes } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const academyArrowSend = keyframes`
  0% {
    transform: translate(0, 0);
    opacity: 1;
  }
  45% {
    transform: translate(4px, -4px);
    opacity: 0;
  }
  46% {
    transform: translate(-4px, 4px);
    opacity: 0;
  }
  100% {
    transform: translate(0, 0);
    opacity: 1;
  }
`

const S = {
  link: css`
    appearance: none;
    border: none;
    background: none;
    font-family: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 12px 16px;
    border-radius: var(--Radius-300);
    ${typo.heading05};
    font-weight: 500;
    color: var(--Colors-Gray-700);
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      background: var(--Colors-Gray-100);

      .academy-link-arrow {
        animation: ${academyArrowSend} 0.85s ease-in-out infinite;

        @media (prefers-reduced-motion: reduce) {
          animation: none;
        }
      }
    }

    &:active {
      background: var(--Colors-Gray-200);
    }
  `,
  arrow: css`
    flex-shrink: 0;
    transform-box: fill-box;
    transform-origin: center;
  `,
}

export default S
